import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, inject, Inject, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { EssentialObjectService } from 'src/app/core/services/essential-object.service';
import { LocalService } from 'src/app/core/services/local.service';
import { DATA_TOKEN, ICDKPortalComponent } from 'src/app/shared/Theme/services/zen-cdk.service';
import { SnackbarInstanceComponent } from './snackbar-instance/snackbar-instance.component';
import { ZenSnackbarService } from '../../services/zen-snackbar.service';
import { BaseComponent } from '@ex/module/core/domain/base-component';
import { debounceTime, filter, startWith, switchMap, take } from 'rxjs/operators';
import { ModuleName } from '@ex/module/shared/enums/ModuleName';
import { fadeUpDown } from '@ex/module/shared/animations/allAnimations';
import { LanguagePipe } from '@ex/module/shared/pipes/language.pipe';

@Component({
  selector: 'zen-snackbar',
  templateUrl: './zen-snackbar.component.html',
  styleUrls: ['./zen-snackbar.component.scss'],
  animations: [fadeUpDown],
  providers: [LanguagePipe]
})
export class ZenSnackbarComponent implements OnInit, AfterViewInit {
  messages = [];
  ModuleNames = ModuleName;
  private _subscriptions = new Subscription()
  language: string;
  rtlPipe = inject(LanguagePipe)
  constructor(private snackbar: ZenSnackbarService, private essentialObject: EssentialObjectService, private localService: LocalService) {


    const data$ = this.snackbar.messages$.pipe(debounceTime(100), filter(x => x?.message != null)).subscribe((x) => {
      // this.language = this.essentialObject?.essentialObject?.value?.language?? 'EN';
      x.show = true;
      this.messages.unshift(x);
      if (this.messages.length > 4) {
        this.messages.pop();
      }
      setTimeout(() => {
        this.removemessage(this.messages[this.messages.indexOf(x)])
      }, x.delay || 3000);
    });
    this._subscriptions.add(data$);
  }
  ngOnInit(): void {
    let localLanguage = this.localService.getJsonValue('language');
    let sessionLanguage = sessionStorage.getItem('language') || sessionStorage.getItem('sessionLanguage');
    if (!localLanguage && !sessionLanguage) {
      this.language = 'EN';
    }
    else if (localLanguage) {
      this.language = localLanguage
    }
    if (sessionLanguage) {
      this.language = sessionLanguage;
    }

  }

  ngAfterViewInit(): void {
    this.dir = this.rtlPipe.transform(this.language) ? 'rtl' : 'ltr';
  }

  removemessage(x: any) {
    if (x?.show)
      x.show = false;
    setTimeout(() => {
      this.messages.splice(this.messages.indexOf(x), 1);
    }, 1000);
  }

  dir: string = 'ltr';

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

}